export class ImpresionAdjuntoConfig {
    basic: BasicConfig;
    cotizacionId: number;
    conductor: string;
    polizaId: string;
    worksiteEnc?: string;
    email?: string;
    polizaIdComplemento?: string;
    medioPago?: boolean; // true = bancario - false = referencia
}

export class EnvioCorreoConfig {
    polizaId: string;
    worksiteEnc: string;
    email: string;
}

export class ErrorConfig {
    servicio?: string;
    cotizacion?: string;
    emision?: string;
    poliza?: string;
    conductor?: string;
}

export class PagoConfig {
    basic: BasicConfig;
    negocioId: number;
    reciboId: string;
    formaPago: string;
    total: string;
    tarjeta: Tarjeta;
    movimiento?: string;
    amis?: string;
    polizaId?: string;
    hasCanceller?: boolean;
    worksiteId?: string;
    grupoId?: number;
    email?: string;
    url?: string;
    recIdComplemento?: string;
    /** 0 Real 0
     *  1 Simulacion Exitosa
     *  2 Simulacion Fallida  */
    escenario: number = 0;
}

export class BasicConfig {
    emisionId: number;
    ciaId?: number;
    ciaString: string;
    clienteId: number;
    noPoliza?: string;
    worksiteId: number;
}

export class PagoReciboConfig {
    reciboId: string;
    base: BasicConfig;
    total: string;
    liquidacion?: string;
    documento?: string;
    formaCobro?: number;
    comentario?: string;
    fecPago?: string;
}

export class VehiculoConductor {
    constructor(
        public c1: string, // no de serie
        public c2: string, // motor
        public c3: string, // placas
        public c4: string, // color
        public c5: string, // nombre del conductor
        public c6: string, // ap paterno
        public c7: string, // ap materno
        public c8: string, // fecha de nacimiento
        public c9: string, // rfc
    ) { }
}

export class Tarjeta {
    public c1: string = "0"; // banco id
    public c2: string = ""; // banco nombre
    public c3: string = ""; // nombre tarjeta
    public c3A: string = ""; // ap_pat tarjeta
    public c3B: string = ""; // ap_mat tarjeta
    public c3C: string = ""; // rfc tarjetahabiente
    public c4: string = ""; // numero tarjeta
    public c5: string = ""; // vencimiento MM
    public c6: string = ""; // num seguridad
    public c7: string = ""; // vencimiento YY
    public c8: string = "1"; // tipo_tarjeta
    public c9: string = ""; // marca_tarjeta
    public c10: string = ""; // fecNac
    public c11: string = ""; // fecNacFormat
    public c12: string = "0"; //modalidad
    public c13?:  string = "1"; //tipo cuenta, credito, debito, etc
}

export class TarjetaDepartamental {
    constructor(
        public c1: string, // tipoTarjeta 1 = con Codigo / 2 = sin Codigo
        public c2: string, // Numero Tarjeta
        public c3: string, // codigo seguridad
    ) { }
}
